import { render, staticRenderFns } from "../templates/normal_fcont_51.html?vue&type=template&id=b710c1f0&"
import script from "./normal_fcont_51.vue?vue&type=script&lang=js&"
export * from "./normal_fcont_51.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports